import { render, staticRenderFns } from "./modalEditBusinessWall.vue?vue&type=template&id=37d95b62&scoped=true&"
import script from "./modalEditBusinessWall.vue?vue&type=script&lang=js&"
export * from "./modalEditBusinessWall.vue?vue&type=script&lang=js&"
import style0 from "./modalEditBusinessWall.vue?vue&type=style&index=0&id=37d95b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d95b62",
  null
  
)

export default component.exports